import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';
import { CustomCurrencyPipe } from '../../../shared/pipes/custom-currency.pipe';
import { Proration } from '../../../types/proration';

@Component({
  selector: 'app-checkout-proration-info',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './checkout-proration-info.component.html',
  styleUrl: './checkout-proration-info.component.scss',
  imports: [CustomCurrencyPipe, TooltipDirective],
})
export class CheckoutProrationInfoComponent {
  proration = input.required<Proration>();
}
